/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FCS API
 * Field Compliance System — REST API
 * OpenAPI spec version: 0.0.54-SNAPSHOT
 */
import { customInstance } from '../../mutator/custom-instance';



  export const getMedia = () => {
/**
 * Serves static image assets used in diagnosis questions. These images provide visual
 * guidance to help vendors understand compliance requirements. This endpoint does not
 * require authentication to allow caching and CDN distribution. Returns 404 if the
 * requested image does not exist.
 * @summary Get a question image by filename
 */
const findMedia = (
    filename: string,
 ) => {
      return customInstance<Blob>(
      {url: `/api/v1/media/${filename}`, method: 'GET',
        responseType: 'blob'
    },
      );
    }
  return {findMedia}};
export type FindMediaResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMedia>['findMedia']>>>
